import React, { useEffect, useState, useContext } from 'react'
import { components, constants, useServices, useTranslation } from 'cng-web-lib'
import AciHighwayCargoApiUrls from 'src/apiUrls/AciHighwayCargoApiUrls'
import FdapnResponseApiUrls from 'src/apiUrls/FdapnResponseApiUrls'
import AciHighwayKeys from 'src/constants/locale/key/AciHighwayResponse'
import Namespace from 'src/constants/locale/Namespace'
import moment from 'moment-timezone'
import {
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@material-ui/core'
import clsx from 'clsx'
import { FdaPNTranslationContext } from './../contexts/FDAPNTranslationContext.js'

const {
  table: { useFetchCodeMaintenanceLookup }
} = components

const {
  filter: { EQUAL }
} = constants

const useStyles = makeStyles((theme) => ({
  table: {
    '& .MuiTableHead-root': {
      backgroundColor: theme.palette.background.sectionOddBg,
      '& .MuiTableCell-head': {
        borderBottom: 0,
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.2,
        textTransform: 'uppercase'
      }
    },
    '& .MuiTableBody-root': {
      '& .MuiTableRow-root': {
        '&:last-child': {
          '& .MuiTableCell-root': {
            borderBottom: 0
          }
        }
      }
    },
    '& .MuiTableCell-root': {
      padding: '8px 16px'
    }
  }
}))

function ResponseSn(props) {
  const { showNotification, id, isViewOnly = false, manifestId, cargoPage, snData } = props

  const [data, setData] = useState([])
  const [lookups, setLookups] = useState(null)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const { fetchRecord, fetchRecords } = useServices()
  const { translate } = useTranslation([Namespace.ACE_HIGHWAY_RESPONSE])
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()
  const classes = useStyles()
  const { getTranslatedText } = useContext(FdaPNTranslationContext)

  const columns = [
    {
      field: 'processingDate',
      title: getTranslatedText('FDAPN', 'processingDate'),
      render: (data) =>
        data.processingDate &&
        moment(data.processingDate).tz("Canada/Eastern").format('D MMM YYYY HH:mm')
    },
    {
      field: 'govAgencyCode',
      title: getTranslatedText('FDAPN', 'govAgencyCode'),
      render: (data) => data.govAgencyCode
    },
    {
      field: 'govAgencyProgramCode',
      title: getTranslatedText('FDAPN', 'govAgencyProgramCode'),
      render: (data) => data.govAgencyProgramCode
    },
    {
      field: 'pgaEntryLevelStatusCode',
      title: getTranslatedText('FDAPN', 'pgaEntryLevelStatusCode'),
      render: (data) => data.pgaEntryLevelStatusCode
    },
    {
      field: 'statusReasonCode',
      title: getTranslatedText('FDAPN', 'statusReasonCode'),
      render: (data) => data.statusReasonCode
    },
    {
      field: 'pgaLine',
      title: getTranslatedText('FDAPN', 'pgaLine'),
      render: (data) => data.pgaLine
    },
    {
      field: 'pgaLineSubReasonCode',
      title: getTranslatedText('FDAPN', 'pgaLineSubReasonCode'),
      render: (data) => {
        if(data.refInfos && data.refInfos.length>0) {
          let pgaLineSubReasonCodeList = []
          data.refInfos.map(refInfo => ( 
            pgaLineSubReasonCodeList.push(refInfo.pgaLineSubReasonCode)
          ));

          return pgaLineSubReasonCodeList.join(", ")
        }
        return "";
      }
    },
    {
      field: 'comments',
      title: getTranslatedText('FDAPN', 'comments'),
      render: (data) => { 
        if(data.narratives && data.narratives.length>0){

          let commentsList = []
          data.narratives.map(narrative => ( 
            commentsList.push(narrative.comments)
          ));

          return commentsList.join(", ")
        }
        return "";
      }
    }
  ]

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value)
    setPage(0)
  }

  return (
    <>
      <TableContainer>
        <Table className={clsx(classes.table, 'new-ui-table-component__table')}>
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <TableCell key={index}>{column.title}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {snData.length > 0 ? (
              snData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((d) => (
                  <TableRow key={d.id}>
                    {columns.map((column, index) => (
                      <TableCell key={index}>
                        {column.render ? column.render(d) : d[column.field]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell align='center' colSpan={columns.length}>
                  <Typography variant='body2' color='textSecondary'>
                    No records to display
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 20, 50, 100, 500, 1000]}
        component='div'
        count={snData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}

export default ResponseSn
